import { CampaignService } from '../../typings/campaignService';

export const INIT_CAMPAIGN_SERVICE_EDITORS = 'INIT_CAMPAIGN_SERVICE_EDITORS';
export type INIT_CAMPAIGN_SERVICE_EDITORS = typeof INIT_CAMPAIGN_SERVICE_EDITORS;

export interface InitCampaignServiceEditors {
    type: INIT_CAMPAIGN_SERVICE_EDITORS;
    payload: CampaignServiceEditorInitData[];
}

export interface CampaignServiceEditorInitData {
    editorId: string;
    service: CampaignService;
}

export function initCampaignServiceEditorsAction(payload: CampaignServiceEditorInitData[]): InitCampaignServiceEditors {
    return {
        type: INIT_CAMPAIGN_SERVICE_EDITORS,
        payload
    };
}
